import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import
import App from './App';
import store from "./store";
import {router} from "./components/Router/Router";
import {RouterProvider} from "react-router-dom";
import {Provider} from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root'));  // No change here

root.render(
    <Provider store={store}>
        <RouterProvider router={router}>
            <App/>
        </RouterProvider>
    </Provider>
);
